import './App.css';
import { GlobalProvider } from '../Context/GlobalContext';
import { HelmetProvider } from "react-helmet-async";

import Header from "../Layout/Header/Header";
import SideBar from "../Layout/SideBar/SideBar";
import Content from '../Layout/Content/Content';
import { useAuth } from "react-oidc-context";
import AlertBar from '../Components/AlertBar/AlertBar';
import { CircularProgress } from '@mui/material';

function App() {
  const auth = useAuth();

  if (auth.isLoading) {
    return <CircularProgress size="6rem" sx={{position: "absolute", top: "40vh", left: "50%", marginTop: "60px"}}/>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <GlobalProvider>
        <HelmetProvider>
          <Header />
          <SideBar/>
          <Content />          
          <AlertBar />
        </HelmetProvider>
      </GlobalProvider>
    );
  }
  
  auth.signinRedirect();
}

export default App;
